import React, { useState, useEffect } from 'react';
import PhoneSearch from './PhoneSearch';
import PhoneStatusCard from './PhoneStatusCard';
import PhoneHistory from './PhoneHistory';
import StatusUpdateForm from './StatusUpdateForm';

const Dashboard = ({ user, onSearch, currentPhone, onUpdateStatus }) => {
  const [justUpdated, setJustUpdated] = useState(false);
  const [summary, setSummary] = useState({ inProgress: 0, completed: 0 });

  const fetchSummary = async () => {
    try {
      const response = await fetch('backend/report.php', { credentials: 'include' });
      const data = await response.json();
      if (data.data) {
        const inProgress = data.data.filter(p => p.status !== 'Finish Good').length;
        const completed = data.data.filter(p => p.status === 'Finish Good').length;
        setSummary({ inProgress, completed });
      }
    } catch (error) {
      console.error('Error al cargar resumen:', error);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, [justUpdated]);

  const handleUpdateStatus = async (imei, updatedPhone) => {
    try {
      const response = await fetch('backend/phones.php', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          imei: imei,
          status: updatedPhone.status,
          history: updatedPhone.history,
        }),
      });
      const result = await response.json();
      if (result.success) {
        onSearch(imei);
        setJustUpdated(true);
        setTimeout(() => setJustUpdated(false), 1000);
      } else {
        alert(result.error || 'Error al actualizar estado');
      }
    } catch (error) {
      console.error('Error al actualizar estado:', error);
    }
  };

  // 🚀 NUEVO: Función para exportar reportes
  const handleExportReport = (startDate, endDate, type) => {
    if (!startDate || !endDate) {
      alert('Por favor seleccione un rango de fechas.');
      return;
    }

    const url = `backend/export_report.php?startDate=${startDate}&endDate=${endDate}&type=${type}`;
    window.open(url, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 space-y-6">
            <PhoneSearch onSearch={onSearch} />

            {currentPhone && currentPhone.status !== 'Finish Good' && (
              <StatusUpdateForm 
                phone={currentPhone} 
                user={user} 
                onUpdateStatus={onUpdateStatus} 
              />
            )}

            {currentPhone && (
              <PhoneHistory history={currentPhone.history} />
            )}

            {/* NUEVO: Botón Exportar Reportes */}
            <div className="bg-white p-4 rounded-lg shadow-md mt-6">
              <h2 className="text-lg font-semibold mb-2">Exportar Reportes</h2>
              <button
                onClick={() => {
                  const startDate = prompt('Fecha inicio (YYYY-MM-DD)');
                  const endDate = prompt('Fecha fin (YYYY-MM-DD)');
                  const type = prompt('Tipo: completed, pending, all', 'all');
                  handleExportReport(startDate, endDate, type);
                }}
                className="bg-[#31a749] hover:bg-green-700 text-white py-2 px-4 rounded-md w-full"
              >
                Exportar Reporte
              </button>
            </div>
          </div>
          <div className="lg:col-span-2 space-y-6">
            {currentPhone ? (
              <>
                <PhoneStatusCard phone={currentPhone} justUpdated={justUpdated} />

                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h2 className="text-xl font-semibold mb-4">Resumen</h2>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-blue-50 p-3 rounded-lg">
                      <p className="text-sm text-blue-800">En proceso</p>
                      <p className="text-2xl font-bold text-blue-900">
                        {summary.inProgress}
                      </p>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg">
                      <p className="text-sm text-green-800">Completados</p>
                      <p className="text-2xl font-bold text-green-900">
                        {summary.completed}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-gray-500">Busque un teléfono para ver su estado</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
